import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Notification from 'modules/Common/components/Notification';
import {Link} from 'react-router';

require('./CookieNotice.scss');

export default class PureCookieNotice extends PureComponent {
    constructor(...args) {
        super(...args);

        this.state = {
            show: false
        }

        this.onDismiss = this.onDismiss.bind(this);
    }

    componentDidMount() {
        this.props.fetchHasAcceptedPolicy();
    }

    componentWillReceiveProps(newProps) {
        if (!newProps.accepted) {
            this.setState({show: true});
        }
    }

    onDismiss() {
        this.setState({show: false});
        this.props.acceptCookiePolicy();
    }

    render() {
        if (!this.state.show) {
            return null;
        }

        return (
            <Notification showClose={false} onDismiss={this.onDismiss} className="cookie-notice">
                <div className="container row center wrap">
                    <p>
                        This website uses cookies. Cookies help us and our third party partners to provide, 
                        protect and improve our services. By visiting or using this website, you consent to the use of 
                        cookies in accordance with our <Link to={this.props.policyLink}>Cookies policy</Link>, which includes details of <Link to={this.props.policyLink}>how you can change your 
                        cookie settings</Link>.
                    </p>
                    <div className="actions">
                        <button className="small-primary-button cookie-notice-accept" onClick={this.onDismiss}>Accept &amp; close</button>
                    </div>
                </div>
            </Notification>
        );
    }
}

PureCookieNotice.propTypes = {
    acceptCookiePolicy: PropTypes.func.isRequired,
    fetchHasAcceptedPolicy: PropTypes.func.isRequired,
    policyLink: PropTypes.string.isRequired,
    accepted: PropTypes.any    
};


// WEBPACK FOOTER //
// ./modules/Common/components/CookieNotice.js